import { styled } from '@mui/material';

import CustomHashLink, { CustomHashLinkProps } from '../CustomHashLink';

export const WrapperLink = styled(CustomHashLink)<CustomHashLinkProps>({
  alignSelf: 'flex-end',
});
